import { SNACKBAR_TIMEOUT } from '../../../project-configuration/const';

type TSnackbarDictionaryItem = {
  id: string;
  title: string;
  content: string;
  type: string;
  time: boolean;
  timeout?: number;
  closeButton?: boolean;
  icon?: true;
};

type TSnackbarDictionary = {
  [key: string]: TSnackbarDictionaryItem;
};

export enum TSnackbarDictionaryKeys {
  CALCULATION_ERROR = 'calculationError',
  SUCCESSFULY_ADD_TO_CART = 'successfulyAddedToCart',
  ERROR_ADD_TO_CART = 'errorAddToCart',
  SAVE_DOOR_PROJECT_CLIENT_ERROR = 'saveDoorProjectClientError',
  SAVE_PROJECT_SERVER_ERROR = 'saveProjectServerError',
  SAVE_LAMINATE_PROJECT_CLIENT_ERROR = 'saveLaminateProjectClientError',
  CALCULATION_WITH_DEFAULT_PARAMS_ERROR = 'calculationWithDefaultParamsError',
}

export const SNACKBARS_DICTIONARY: TSnackbarDictionary = {
  calculationError: {
    id: `${TSnackbarDictionaryKeys.CALCULATION_ERROR}`,
    title: 'Попробуйте повторить',
    content: 'Не удалось расчитать товары',
    type: 'alert',
    time: true,
  },
  serviceError: {
    id: `${TSnackbarDictionaryKeys.CALCULATION_ERROR}`,
    title: 'Попробуйте повторить',
    content: 'Не удалось перейти к оформлению замера',
    type: 'alert',
    time: true,
  },
  successfulyAddedToCart: {
    id: `${TSnackbarDictionaryKeys.SUCCESSFULY_ADD_TO_CART}`,
    title: 'Товары добавлены в корзину',
    content: 'Перейдите в корзину для оформления или продолжите покупки',
    type: 'success',
    time: true,
  },
  errorAddToCart: {
    id: `${TSnackbarDictionaryKeys.ERROR_ADD_TO_CART}`,
    title: 'Попробуйте повторить',
    content: 'Не удалось добавить товары в корзину',
    type: 'alert',
    time: true,
  },
  saveDoorProjectClientError: {
    id: `${TSnackbarDictionaryKeys.SAVE_DOOR_PROJECT_CLIENT_ERROR}`,
    title: 'Не удалось сохранить параметры двери',
    content: 'Попробуйте ещё раз',
    type: 'error',
    time: true,
    timeout: SNACKBAR_TIMEOUT,
    closeButton: true,
    icon: true,
  },
  saveProjectServerError: {
    id: `${TSnackbarDictionaryKeys.SAVE_PROJECT_SERVER_ERROR}`,
    title: 'Что-то пошло не так',
    content: 'Попробуйте ещё раз',
    type: 'error',
    time: true,
    timeout: SNACKBAR_TIMEOUT,
    closeButton: true,
    icon: true,
  },
  saveLaminateProjectClientError: {
    id: `${TSnackbarDictionaryKeys.SAVE_LAMINATE_PROJECT_CLIENT_ERROR}`,
    title: 'Попробуйте повторить',
    content: 'Не удалось подобрать товары',
    type: 'error',
    time: true,
    timeout: SNACKBAR_TIMEOUT,
    closeButton: true,
    icon: true,
  },
  calculationWithDefaultParamsError: {
    id: `${TSnackbarDictionaryKeys.CALCULATION_WITH_DEFAULT_PARAMS_ERROR}`,
    title: 'Попробуйте повторить',
    content: 'Произошла техническая ошибка',
    type: 'alert',
    time: true,
    timeout: SNACKBAR_TIMEOUT,
  },
};
